import React, { FC } from "react";

const warrant: FC = () => {
    return (
        <svg viewBox="0 0 57 55" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M56.8333 27.125L50.6333 19.8917L51.4083 10.3333L42.1083 8.26667L37.2 0L28.4167 3.875L19.6333 0L14.725 8.26667L5.425 10.3333L6.2 19.8917L0 27.125L6.2 34.3583L5.425 43.9167L14.725 45.9833L19.6333 54.25L28.4167 50.375L37.2 54.25L42.1083 45.9833L51.4083 43.9167L50.6333 34.3583L56.8333 27.125ZM45.725 39.7833L38.75 41.3333L35.1333 47.5333L28.4167 44.6917L21.7 47.5333L18.0833 41.3333L11.1083 39.7833L11.625 32.55L6.975 27.125L11.625 21.7L11.1083 14.4667L18.0833 12.9167L21.7 6.71667L28.4167 9.55833L35.1333 6.71667L38.75 12.9167L45.725 14.4667L45.2083 21.7L49.8583 27.125L45.2083 32.55L45.725 39.7833ZM40.3 15.7583L43.9167 19.375L23.25 40.0417L12.9167 29.7083L16.5333 26.0917L23.25 32.8083L40.3 15.7583Z"
                fill="#E30613"
            />
        </svg>
    );
};

export default React.memo(warrant);
